import apiClient from "./apiClient";
import { CreateUnitRequest } from "../models/RequestModels/CreateUnitRequest";
import { ApiCollectionResponse } from "../models/ResponseModels/ApiCollectionResponse";
import { ApiSingleResponse } from "../models/ResponseModels/ApiSingleResponse";
import { UnitResponse } from "../models/ResponseModels/UnitResponse";

export const getUnitsRequest = async (): Promise<
  ApiCollectionResponse<UnitResponse>
> => {
  const response =
    await apiClient.get<ApiCollectionResponse<UnitResponse>>("/units");
  return response.data;
};

export const getUnitRequest = async (
  id: number,
): Promise<ApiSingleResponse<UnitResponse>> => {
  const response = await apiClient.get<ApiSingleResponse<UnitResponse>>(
    `/units/${id}`,
  );
  return response.data;
};

export const createUnitRequest = async (
  body: CreateUnitRequest,
): Promise<ApiSingleResponse<UnitResponse>> => {
  const response = await apiClient.post<ApiSingleResponse<UnitResponse>>(
    "/units",
    body,
  );
  return response.data;
};

export const updateUnitRequest = async (
  id: number,
  body: Partial<CreateUnitRequest>,
): Promise<ApiSingleResponse<UnitResponse>> => {
  const response = await apiClient.patch<ApiSingleResponse<UnitResponse>>(
    `/units/${id}`,
    body,
  );

  return response.data;
};

export const deleteUnitRequest = async (id: number): Promise<void> => {
  await apiClient.delete(`/units/${id}`);
};
